import {
    Heart,
    UtensilsCrossed,
    IndianRupee,
    Store,
} from "lucide-react";

import getImageUrl from "../../../utils/imageUrl";

import "./FavouriteFoodsCard.css";

function FavouriteFoodsCard({ favouriteFoods }) {

    if (!favouriteFoods || favouriteFoods.length === 0) {

        return (
            <div className="customer-card">

                <h2 className="customer-card-title">
                    Favourite Foods
                </h2>

                <p className="customer-empty">
                    No favourite foods yet.
                </p>

            </div>
        );

    }

    return (
        <div className="customer-card">

            <h2 className="customer-card-title">
                Favourite Foods
            </h2>

            <div className="favourite-foods-list">

                {favouriteFoods.map((food) => {

                    const imageUrl = food.image
                        ? getImageUrl(food.image)
                        : "";

                    return (
                        <div
                            key={food._id}
                            className="favourite-food-card"
                        >

                            <div className="favourite-food-image">

                                {imageUrl ? (
                                    <img
                                        src={imageUrl}
                                        alt={food.foodName}
                                        onError={(e) => {
                                            e.currentTarget.style.display =
                                                "none";
                                        }}
                                    />
                                ) : (
                                    <div className="no-image">
                                        🍽️
                                    </div>
                                )}

                            </div>

                            <div className="favourite-food-content">

                                <h3>
                                    <UtensilsCrossed size={16} />
                                    {" "}
                                    {food.foodName}
                                </h3>

                                <p>
                                    <Store size={15} />
                                    {" "}
                                    {food.provider?.business?.businessName ||
                                        "Provider"}
                                </p>

                                <p>
                                    <IndianRupee size={15} />
                                    {" "}
                                    ₹{food.price}
                                </p>

                            </div>

                            <div className="favourite-food-heart">

                                <Heart
                                    size={18}
                                    fill="currentColor"
                                />

                            </div>

                        </div>
                    );
                })}

            </div>

        </div>
    );
}

export default FavouriteFoodsCard;